/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import { Button, ButtonSizeType, ButtonStyleType, ICourse, LoadingSpinner } from "@into-discovery/browsewebshared";
import color from "../../../../../styles/_helpers/branding.module.scss";
import SearchResultsRow from "../search-results-row/search-results-row";
import { useTranslations } from "next-intl";

type Props = {
  searchQueryId: string;
  courses: ICourse[];
  loadNextPage: () => void;
  isDataLoading: boolean;
  isNextPageAvailable: boolean;
  totalCourses: number;
  defaultPageSize: number;
  isBreakpointLgUp: boolean;
  isBreakpointMediumUp: boolean;
  brandCountryCode: string;
  brandPrimaryColor: string;
  themeColor: string;
  invertedTheme: boolean;
  handleApplyClick: (toggleModal: boolean, courseName: string, courseApplyURL: string) => void;
};

export default function SearchResults({
  courses,
  loadNextPage,
  isDataLoading,
  isNextPageAvailable,
  totalCourses,
  defaultPageSize,
  searchQueryId,
  isBreakpointLgUp,
  isBreakpointMediumUp,
  brandCountryCode,
  brandPrimaryColor,
  themeColor,
  invertedTheme,
  handleApplyClick
}: Props) {
  const renderData = useMemo(() => {
    const nextSetOfProgramCount =
      totalCourses - courses.length > defaultPageSize ? defaultPageSize : totalCourses - courses.length;
    return { nextSetOfProgramCount };
  }, [courses, defaultPageSize, totalCourses]);

  const translate = useTranslations(`Common`);
  if (!courses?.length) {
    return <p>{brandCountryCode === "US" ? translate(`no-results-us`) : translate(`no-results-uk`)}</p>;
  }
  return (
    <>
      <div className="results">
        {courses.map((course, index) => (
          <SearchResultsRow
            key={`${course.mainProgram.outcomeId}-${course.mainProgram.id}`}
            course={course}
            searchQueryId={searchQueryId}
            searchPosition={index + 1}
            isBreakpointLgUp={isBreakpointLgUp}
            isBreakpointMediumUp={isBreakpointMediumUp}
            brandPrimaryColor={brandPrimaryColor}
            themeColor={themeColor}
            invertedTheme={invertedTheme}
            handleApplyClick={handleApplyClick}
          />
        ))}
      </div>
      {(isNextPageAvailable || isDataLoading) && (
        <div className="d-flex justify-content-center align-items-center mt-3">
          {!isDataLoading && (
            <Button
              buttonID="show-more-search-results"
              buttonAriaLabel="show more search results"
              buttonName="show more search results"
              buttonStyle={ButtonStyleType.Outline}
              buttonSize={ButtonSizeType.Medium}
              copyColor={invertedTheme ? brandPrimaryColor : themeColor}
              outlineColor={invertedTheme ? brandPrimaryColor : themeColor}
              backgroundColor={color.white}
              hoverBackgroundColor={invertedTheme ? brandPrimaryColor : themeColor}
              activeBackgroundColor={invertedTheme ? brandPrimaryColor : themeColor}
              onClick={loadNextPage}
              buttonRole="button"
            >
              Show {renderData.nextSetOfProgramCount} more
            </Button>
          )}
          {isDataLoading && <LoadingSpinner src="/next-assets/loaders/into.svg" />}
        </div>
      )}
    </>
  );
}
